import React from 'react';
import { Box, Typography } from '@mui/material';
import PendingIcon from '@mui/icons-material/HourglassEmpty';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import SyncIcon from '@mui/icons-material/Sync';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ErrorIcon from '@mui/icons-material/Error';

const STATS_CONFIG = [
  { key: 'total_pending_approval', label: 'Pending Review',   color: '#F59E0B', Icon: PendingIcon,      pulse: true  },
  { key: 'total_approved_today',   label: 'Approved Today',   color: '#22C55E', Icon: CheckCircleIcon,  pulse: false },
  { key: 'total_rejected_today',   label: 'Rejected Today',   color: '#EF4444', Icon: CancelIcon,       pulse: false },
  { key: 'total_processing_jobs',  label: 'Processing',       color: '#3B82F6', Icon: SyncIcon,         pulse: false },
  { key: 'total_completed_today',  label: 'Completed Today',  color: '#22C55E', Icon: TaskAltIcon,      pulse: false },
  { key: 'total_failed_today',     label: 'Failed Today',     color: '#EF4444', Icon: ErrorIcon,        pulse: false },
];

const AdminStatsCards = ({ stats, loading }) => {
  if (loading || !stats) {
    return (
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3,1fr)', lg: 'repeat(6,1fr)' }, gap: 2, mb: 4 }}>
        {[...Array(6)].map((_, i) => (
          <Box key={i} sx={{
            backgroundColor: '#0A0A0A', border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: '10px', p: 2.5, minHeight: 90,
          }} />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3,1fr)', lg: 'repeat(6,1fr)' }, gap: 2, mb: 4 }}>
      {STATS_CONFIG.map(({ key, label, color, Icon, pulse }) => {
        const value = stats[key] ?? 0;
        const isAlert = pulse && value > 0;
        return (
          <Box key={key} sx={{
            backgroundColor: '#0A0A0A',
            border: `1px solid ${isAlert ? `${color}30` : 'rgba(255,255,255,0.06)'}`,
            borderRadius: '10px',
            p: 2.5,
            position: 'relative',
            transition: 'border-color 0.2s',
            '&:hover': { borderColor: `${color}30` },
          }}>
            {isAlert && (
              <Box sx={{
                position: 'absolute', top: 10, right: 10,
                width: 7, height: 7, borderRadius: '50%', backgroundColor: color,
                animation: 'statPulse 1.8s ease-in-out infinite',
                '@keyframes statPulse': {
                  '0%, 100%': { opacity: 1, transform: 'scale(1)' },
                  '50%':      { opacity: 0.4, transform: 'scale(0.8)' },
                },
              }} />
            )}

            <Box sx={{
              width: 30, height: 30, borderRadius: '7px',
              backgroundColor: `${color}15`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              mb: 1.5,
            }}>
              <Icon sx={{ fontSize: 16, color }} />
            </Box>

            <Typography sx={{
              fontFamily: 'Inter, sans-serif', fontWeight: 800,
              fontSize: '1.75rem', color: '#FFFFFF', lineHeight: 1, mb: 0.5,
            }}>
              {value}
            </Typography>
            <Typography sx={{
              fontFamily: 'Inter, sans-serif', fontSize: '11px',
              color: 'rgba(255,255,255,0.4)', fontWeight: 500, lineHeight: 1.3,
            }}>
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default AdminStatsCards;
